import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import * as bookActions from '../../actions/bookActions';
import * as accountActions from '../../actions/accountActions';
import { ROLE } from '../../const';
import BookContainer from './BookContainer';
import ContentUploadBar from '../ContentUploadBar/ContentUploadBar';
import { I18n } from 'react-redux-i18n-lite';
import { withRouter } from 'react-router';
import routerHistory from '../../routerHistory';
import { CLASSROOMS_ROUTE } from '../../services/api/apiConst';

class BookContent extends React.Component {
  static propTypes = {
    book: PropTypes.object.isRequired,
    books: PropTypes.array,
    classroom: PropTypes.object,
    routeParams: PropTypes.object,
    bookActions: PropTypes.object,
    user: PropTypes.object,
    location: PropTypes.object,
    uploadStatus: PropTypes.object,
    headerBook: PropTypes.string,
    role: PropTypes.string
  };

  state = {
    bookLoaded: false
  };

  constructor(props, context) {
    super(props, context);
    this.findPicture = this.findPicture.bind(this);
  }

  componentDidMount() {
    const { routeParams, bookActions } = this.props;
    let bookId = routeParams.idBook;
    let classroomId = routeParams.idClassroom;
    bookActions.getBooksData(classroomId);
    bookActions.getBookInfo(classroomId, bookId).then(() => {
      this.setState({
        bookLoaded: true
      });
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { routeParams, bookActions, book, classroom } = this.props;
    let bookId = routeParams.idBook;
    let classroomId = routeParams.idClassroom;
    if ((book.id && bookId !== book.id) || (classroom.id && classroomId !== classroom.id)) {
      bookActions.getBookInfo(classroomId, bookId).then(() => {
        this.setState({
          bookLoaded: true
        });
      });
    }
  }

  componentWillUnmount() {
    const { bookActions } = this.props;
    bookActions.setBookInfo();
  }

  findPicture(id) {
    const { books, headerBook } = this.props;
    let book = _.find(books, { activityId: id });
    if (book && book.image) return book.image;
    if (headerBook) return headerBook;
  }

  checkIsSynchronized(id) {
    const { books } = this.props;
    let book = _.find(books, { activityId: id });
    return book && book.synchronized === true;
  }

  render() {
    const { role, routeParams, book, location, uploadStatus } = this.props;
    const { bookLoaded } = this.state;

    if (bookLoaded && Object.keys(book).length === 0 && !location.query.unitId) {
      routerHistory.push(CLASSROOMS_ROUTE + '/' + routeParams.idClassroom);
    }

    let isComplete = false;
    if (role === ROLE.INSTRUCTOR) {
      isComplete = true;
    }
    let classroomId = routeParams.idClassroom;
    let bookId = routeParams.idBook;

    this.checkIsSynchronized(book.activityId);

    let imageSrc = this.findPicture(book.activityId);
    return (
      <div className="book-content-wrapper">
        <BookContainer
          book={this.props.book}
          unitId={location.query.unitId}
          isComplete={isComplete}
          imageSrc={imageSrc}
          classroomId={classroomId}
          bookId={bookId}
          selectedUnit={location.query.selectedUnit}
        />
        <ContentUploadBar percent={uploadStatus.percentCompleted} isUploading={uploadStatus.isUploading} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    role: state.classrooms.selectedClassroom.classroom.role,
    book: state.book.book,
    uploadStatus: state.book.uploadContentStatus,
    books: state.book.books,
    classroom: state.classrooms.selectedClassroom.classroom,
    openNewUnit: state.book.openNewUnit,
    openUnit: state.book.openUnit,
    language: state.account.user.language,
    i18n: state.i18n,
    headerBook: state.theme.images.headers.book
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BookContent));
